import React, { useEffect, useState } from "react";
import { useAuth } from "../utilities/AuthContext.js";
import Gallery from "../components/Gallery";
import { getDocs, collection, query, where } from "firebase/firestore";
import { db } from "../firebase.js";
import { useNavigate } from "react-router-dom";
import {getStorage, ref, listAll, getDownloadURL} from "firebase/storage";
function Profile() {
  const { currentUser, logout } = useAuth();
  const [balance, setBalance] = useState(0);
  const [numPosters, setNumPosters] = useState(0);
  const [posterList, setPosterList] = useState([]); // [url, likes, liked_by_user
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const storage = getStorage();
  // console.log(currentUser);
  const getBalance = async () => {
    const q = query(
      collection(db, "Users"),
      where("uid", "==", currentUser.uid)
    );
    const querySnapshot = await getDocs(q);
    // console.log(querySnapshot);
    querySnapshot.forEach((doc) => {
      // console.log(doc.data());
      setBalance(doc.data().balance);
      setNumPosters(doc.data().history.length);
      setName(doc.data().name);
      // setHistList();
      const data = doc.data().history.map((url) => {
        return{
          url: url,
          likes: "1k",
          liked_by_user: Math.floor(Math.random() * 10) % 2 === 0,
        };
      });
      // console.log(data);
      setPosterList(data);
    });
  };
  useEffect(() => {
    getBalance();
  }, [])
  return (
    <div className="text-left">
      {/* <h1 className="text-center text-4xl font-bold p-2">My Profile</h1> */}
      <div className="mt-4 mb-8 flex lg:flex-row flex-wrap justify-center">
        <header className="flex flex-col lg:flex-row items-center p-2 w-full justify-between px-0 lg:px-20 xl:px-40">
          <div className="flex flex-col sm:flex-row items-center p-2">
            <div className="w-40 h-40">
              <img
                className="rounded-full shadow-md border-gray-300 border-2 w-full h-full"
                src={currentUser.photoURL || "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"}
                alt=""
              />
            </div>
            <div className="sm:mx-4 text-center sm:text-left flex justify-center flex-col w-48 truncate">
              <h2 className="text-2xl truncate whitespace-nowrap font-bold mb-3">{currentUser.displayName}</h2>
              <button className="bg-blue-500 border-blue-500 border-2 hover:bg-blue-700 hover:border-blue-700 text-white font-bold py-1 md:py-2 px-3 md:px-4 rounded-full mt-1 text-md" onClick={()=>navigate("/pricing")}>
                Get Credits
              </button>
              <button className="bg-red-500 border-red-500 border-2 hover:bg-red-700 hover:border-red-700 text-white font-bold py-1 md:py-2 px-3 md:px-4 rounded-full mt-1 text-md" onClick={()=>{logout();navigate("/login")}}>
                Sign Out
              </button>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row h-full w-64 sm:w-auto space-y-2 sm:space-y-0 sm:space-x-2">
            <div className="h-full w-full sm:w-56 border rounded-lg shadow-sm p-4 flex flex-col">
              <h2 className="text-3xl font-bold">Credits</h2>
              <h3 className="text-center text-3xl font-bold text-green-500 my-auto">{balance}</h3>
            </div>
            <div className="h-full w-full sm:w-56 border rounded-lg shadow-sm p-4 flex flex-col">
              <h2 className="text-3xl font-bold">Posters</h2>
              <h3 className="text-center text-3xl font-bold text-green-500 my-auto">{numPosters}</h3>
            </div>
          </div>
        </header>
        {/* <div className="flex flex-col p-4 bg-white flex-1 m-2 md:mx-10 rounded-md shadow-md text-lg justify-center" style={{minWidth:"350px"}}>
          <h2 className="text-2xl text-center">Account Details</h2>
          <p>
          Current Plan: <span>{userData.currentPlan}</span>
          </p>
          <p>
          Posters Generated by User: <span>{userData.postersGenerated}</span>
          </p>
          <p>
          Credits spent on platform: <span>{userData.creditsSpent}</span>
          </p>
        </div> */}
      </div>
      <Gallery posters={posterList} />
    </div>
  );
}

export default Profile;
